export const ADDUSER = 'addUser';//保存用户信息
export const SYNCADDUSER = 'syncAddUser';//异步保存用户信息
export const CLEARUSER = 'clearUser';//清除USER
export const SYNCCLEARUSER = 'clearUser';//异步清除USER
export const USERSTATUS = 'userStatus';//判断用户状态
export const SYNCUSERSTATUS = 'syncUserStatus';//异步判断用户状态